// Considered: ButtonAtom — rejected because ButtonAtom has no icon-only variant (its icon-square shape still
// pads for a label and has no hit-area extension); this reuse was repeated across 877 and 938. See spec Reuse Audit.
import React, { useRef } from 'react';
import TooltipAtom from '../Tooltip/TooltipAtom';
import './IconButtonAtom.scss';

export interface IconButtonAtomProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'aria-label' | 'children'> {
  /** PrimeIcons class (e.g. `pi pi-link`), or a ReactNode for a glyph PrimeIcons lacks (e.g. a lucide icon). */
  icon: string | React.ReactNode;
  /** Required: an icon alone names nothing. Also the hover tooltip text. */
  'aria-label': string;
}

const IconButtonAtom: React.FC<IconButtonAtomProps> = ({ icon, className, type = 'button', ...rest }) => {
  const ref = useRef<HTMLButtonElement>(null);
  const label = rest['aria-label'];
  return (
    <>
      <button
        {...rest}
        ref={ref}
        type={type}
        className={['icon-button-atom', className].filter(Boolean).join(' ')}
        data-pr-tooltip={label}
        data-pr-position="top"
      >
        {typeof icon === 'string' ? <i className={icon} aria-hidden="true" /> : <span className="icon-button-atom__glyph" aria-hidden="true">{icon}</span>}
      </button>
      <TooltipAtom target={ref} content={label} position="top" />
    </>
  );
};

IconButtonAtom.displayName = 'IconButtonAtom';

export default IconButtonAtom;
